(() => {
  'use strict';
  function initialize(scope) {
    const roots = scope.matches?.('[data-tun-archetype]') ? [scope] : scope.querySelectorAll('[data-tun-archetype]');
    roots.forEach(root => {
      if(root.dataset.talInitialized) return;
      root.dataset.talInitialized = 'true';
      const inputs = root.querySelectorAll('.tal-pack input[name="id"]');
      const updatePack = () => {
        const selected = root.querySelector('.tal-pack input[name="id"]:checked');
        if(!selected || selected.disabled) return;
        inputs.forEach(input => input.closest('.tal-pack').classList.toggle('tal-selected', input.checked));
        const count = selected.dataset.count;
        const price = selected.dataset.priceLabel;
        const label = root.querySelector('#tal-purchase-label');
        const mobile = root.querySelector('#tal-mobile-price');
        if(label) label.textContent = 'Add ' + count + ' cans — ' + price;
        if(mobile) mobile.textContent = count + ' cans · ' + price;
      };
      inputs.forEach(input => input.addEventListener('change', updatePack));
      updatePack();
      const hero = root.querySelector('#tal-hero-image');
      const frame = root.querySelector('.tal-photo-frame');
      const thumbnails = root.querySelectorAll('.tal-thumb');
      thumbnails.forEach(button => button.addEventListener('click', () => {
        if(!hero || !frame) return;
        hero.src = button.dataset.image;
        hero.alt = button.dataset.alt;
        frame.classList.toggle('tal-award-selected', button.dataset.award === 'true');
        frame.classList.toggle('tal-glass-selected', button.dataset.glass === 'true');
        thumbnails.forEach(item => {
          item.classList.toggle('tal-active', item === button);
          item.setAttribute('aria-pressed', String(item === button));
        });
      }));
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
